// Module
var code = `<template> <div class="page-due-diligence-documents animation-slide-bottom"> <partial-documents-management vessel-id.bind="vesselId"></partial-documents-management> </div> </template>`;
// Exports
module.exports = code;